module.exports = __webpack_public_path__ + "static/media/3_r_stol.71.3_62.78.43722416.png";